// import './Crew.scss'

import data from '../../../data.json'
import { useState } from 'react'
import { useSetBodyBackgrounds } from '../../../shared/bodyBackgrounds'

const Crew = () => {
    const [crew] = useState(data.crew)
    const [currentIndex, setCurrentIndex] = useState(0)

    // Call Custom Hook to set Body Backgrounds
    useSetBodyBackgrounds('crew-bg')

    const {
        name,
        images: { png: image },
        role,
        bio,
    } = crew[currentIndex]

    const crewLinks = crew.map((member, index) => {
        return (
            <li key={member.name} className='crew__nav-item'>
                <button
                    className={`crew__nav-link ${
                        index === currentIndex ? 'active' : ''
                    }`}
                    onClick={() => setCurrentIndex(index)}
                ></button>
            </li>
        )
    })

    return (
        <div className='container'>
            <div className='crew maincontent'>
                <h1 className='crew__main-heading '>
                    <span>02</span>Meet your crew
                </h1>
                {/* <section className='crew__left'> */}
                <figure className='crew__img-container'>
                    <img className='crew__img' src={image} alt={name} />
                </figure>
                <hr />
                {/* </section> */}
                {/* <section className='crew__right'> */}
                <ul className='crew__nav-list'>{crewLinks}</ul>
                <section className='crew__info'>
                    <p className='crew__role'>{role}</p>
                    <h1 className='crew__name'>{name}</h1>
                    <p className='crew__bio'>{bio}</p>
                </section>
            </div>
        </div>
    )
}

export default Crew
